import { motion } from 'framer-motion';
import { ArrowDown } from '@phosphor-icons/react';

const Hero = ({ onQuoteClick }) => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_build-website-154/artifacts/g8t7uehb_hero-banner-image.jpg"
          alt="Rimsie Constructions Pty Ltd - Bar Renovation"
          className="w-full h-full object-cover"
        />
        <div className="hero-gradient absolute inset-0" />
      </div>

      <div className="container-custom relative z-10 pt-20">
        <div className="max-w-4xl">
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }} className="overline mb-6">
            Licensed Builder &bull; NSW Central Coast
          </motion.p>

          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }} data-testid="hero-headline"
            className="text-5xl sm:text-6xl lg:text-7xl font-heading font-light text-heading leading-tight mb-4">
            Built Right.<br />
            On Time. <span className="text-accent">Every Time.</span>
          </motion.h1>

          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.45 }}
            className="text-3xl sm:text-4xl lg:text-5xl font-heading font-light text-heading/60 mb-10">
            Rimsie Constructions Pty Ltd
          </motion.p>

          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }} data-testid="hero-subheadline"
            className="text-lg md:text-xl text-body-text max-w-2xl mb-10 leading-relaxed">
            Rimsie Constructions Pty Ltd delivers commercial and residential builds across the NSW Central Coast.
            Brett Rimmer coordinates every trade, every stage.
          </motion.p>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.7 }} className="flex flex-col sm:flex-row gap-4">
            <button onClick={onQuoteClick} data-testid="hero-cta-quote" className="btn-primary text-center">
              Get a Free Quote
            </button>
            <a href="#gallery" onClick={(e) => scrollToSection(e, '#gallery')}
              data-testid="hero-cta-work" className="btn-secondary text-center">
              See Our Work
            </a>
          </motion.div>
        </div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.2 }}
          className="absolute bottom-10 left-1/2 -translate-x-1/2">
          <motion.div animate={{ y: [0, 10, 0] }} transition={{ duration: 1.5, repeat: Infinity }}>
            <ArrowDown size={32} className="text-heading/50" weight="light" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
